import TableExport from './table-export';
import { BaseEntity, JsonApiResource } from '../jsonapi-provider';
import { type DisplayConfig } from '../types';
import { type LocalDate } from '../utils/local-date';
import type PrepSheetRevision from './prep-sheet-revision';

@JsonApiResource({
  type: 'prep-sheet-configuration',
})
export default class PrepSheetConfiguration extends BaseEntity {
  constructor(
    public name: string = '',
    public flags: Array<keyof DisplayConfig> = ['showSummary'],
    public site: string[] | undefined | null,
    public mealCategory: string[] | undefined | null,
    public mainType: string[] | undefined | null,
    public prepSheetRevisions: PrepSheetRevision[] | undefined = undefined
  ) {
    super();
  }

  toTableExportOfPrepSheetRevision(
    orderDate: LocalDate,
    serializedHeaderAttributes?: string,
    prepSheetRevisionId?: string
  ): TableExport {
    const queryParams = ['fields[prep-sheet-revision]='];

    const filters = this.serializeFiltersQueryOfPrepSheetRevision(prepSheetRevisionId);
    if (filters?.length) {
      queryParams.push(filters);
    }

    if (serializedHeaderAttributes?.length) {
      queryParams.push(serializedHeaderAttributes);
    }

    return new TableExport(undefined, `/prep-sheet-revision?${queryParams.join('&')}`, 'PDF');
  }

  toTableExport(
    orderDate: LocalDate,
    serializedHeaderAttributes?: string,
    prepSheetRevisionId?: string
  ): TableExport {
    const queryParams = ['fields[site-menu-order]='];

    const filters = this.serializeFiltersQuery(orderDate, prepSheetRevisionId);
    if (filters?.length) {
      queryParams.push(filters);
    }

    if (this.flags.length) {
      queryParams.push(this.flags.map((flag) => `${flag}=true`).join('&'));
    }

    if (serializedHeaderAttributes?.length) {
      queryParams.push(serializedHeaderAttributes);
    }

    return new TableExport(undefined, `/site-menu-order?${queryParams.join('&')}`, 'PDF');
  }

  private serializeFiltersQuery(
    orderDate: LocalDate,
    prepSheetRevisionId?: string
  ): string | undefined {
    const parts: string[] = [];
    if (prepSheetRevisionId) parts.push(`id=='${prepSheetRevisionId}'`);
    if (this.mealCategory?.length) {
      parts.push(
        `scheduledMeal.mealCategory.id=in=(${this.mealCategory.map((id) => `${id}`).join(',')})`
      );
    }
    if (this.mainType?.length) {
      parts.push(`mainType=ini=(${this.mainType.map((id) => `'${id}'`).join(',')})`);
    }
    if (this.site?.length) {
      parts.push(`site.id=in=(${this.site.map((id) => `${id}`).join(',')})`);
    }

    return parts.length ? `filter[site-menu-order]=${parts.join(';')}` : undefined;
  }

  private serializeFiltersQueryOfPrepSheetRevision(
    prepSheetRevisionId?: string
  ): string | undefined {
    const parts: string[] = [];
    if (prepSheetRevisionId) parts.push(`id=='${prepSheetRevisionId}'`);

    return parts.length ? `filter[prep-sheet-revision]=${parts.join(';')}` : undefined;
  }
}
